<div class="success-message">
  <div class="success-message__animation">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 154 154"
    >
      <g fill="none" stroke="#568722" stroke-width="2">
        <circle
          class="success_icon__outer_circle"
          cx="77"
          cy="77"
          r="72"
          style="stroke-dasharray: 480px, 480px; stroke-dashoffset: 960px"
        ></circle>
        <circle
          class="success_icon__inner_circle"
          fill="#568722"
          cx="77"
          cy="77"
          r="72"
          style="stroke-dasharray: 480px, 480px; stroke-dashoffset: 960px"
        ></circle>
        <polyline
          class="success_icon__checkmark"
          stroke="#fff"
          stroke-width="10"
          points="43.5,77.8 63.7,97.9 112.2,49.4 "
          style="stroke-dasharray: 100px, 100px; stroke-dashoffset: 200px"
        ></polyline>
      </g>
    </svg>
  </div>

  <h3 class="success-message__title">
    {{ 'searchSubscription.successMessage.title' | i18n }}
  </h3>

  <p class="success-message__text">
    {{ 'searchSubscription.successMessage.paragraph1' | i18n }}
  </p>

  <p class="success-message__text">
    {{ 'searchSubscription.successMessage.paragraph2' | i18n }}
  </p>

  <div class="success-message__button-wrapper">
    <ng-content></ng-content>
  </div>
</div>
